import React, { useEffect } from 'react'
import { compose } from 'redux'

import _ from 'underscore'
import { Link as Navigate } from 'react-router-dom'

import { IntroductionContent } from '../components/Content/ModulesScreen'
import ModulesTable from '../components/Table/ModulesTable'
import withSelected from '../hocs/withData/withSelected'

const ScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return null
}

const Redirection = ({ TestSelected = '' }) => (TestSelected === 0 ? <Navigate to="/" /> : null)

const ModulesScreen = ({ Selected = {} }) => {
  const TestSelected = _.values(Selected).length

  return (
    <>
      <Redirection TestSelected={TestSelected} />
      <ScrollToTopOnMount />
      <div id="main">
        <div className="container modules-page">
          <IntroductionContent />
          <ModulesTable />
        </div>
      </div>
    </>
  )
}

export default compose(withSelected)(ModulesScreen)
